import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Dialog, DialogContent, DialogFooter, DialogHeader, Inline, Stack, Text } from '@ui-lib';
import { vars } from '@ui-lib/css';
import type { FormEvent, ReactNode } from 'react';

interface DeleteDialogProps {
  icon?: ReactNode;
  title: string;
  onClose: () => void;
  onCancel: () => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export const DeleteDialog = ({
  icon,
  title,
  onClose,
  onCancel,
  onSubmit,
}: DeleteDialogProps): JSX.Element => (
  <form onSubmit={onSubmit}>
    <Dialog>
      <DialogHeader leadingIcon={icon} title={title} onClose={onClose} />
      <DialogContent>
        <Stack gap="medium">
          <Inline alignY="center" gap="xsmall">
            <FontAwesomeIcon color={vars.color.foreground.critical} icon={faTriangleExclamation} />
            <Text tone="critical" weight="demibold">
              Delete this field?
            </Text>
          </Inline>
          <Text>The information will be deleted</Text>
        </Stack>
      </DialogContent>
      <DialogFooter>
        <Box display="flex" justifyContent="flexEnd" gap="small">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" variant="solid">
            Delete
          </Button>
        </Box>
      </DialogFooter>
    </Dialog>
  </form>
);
